export default "__VITE_ASSET__DGtk94_N__"